module.exports = __webpack_public_path__ + "static/media/men.0785f023.png";